var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7652 5.06338C15.1459 5.23333 15.3223 5.69258 15.1591 6.08913L14 8.70892H18.7886L17.6061 6.08911C17.4429 5.69256 17.6193 5.23331 18 5.06336C18.3807 4.89341 18.8216 5.07711 18.9848 5.47366L20.4206 8.70892H21.5C21.7761 8.70892 22 8.96002 22 9.26977V9.83062C22 10.1404 21.7761 10.3915 21.5 10.3915H21L20.4206 15.0338C20.3514 15.5878 19.929 16 19.4302 16H13.5698C13.071 16 12.6486 15.5878 12.5794 15.0338L12 10.3915H11.5C11.2239 10.3915 11 10.1404 11 9.83062V9.26977C11 8.96002 11.2239 8.70892 11.5 8.70892H12.368L13.7804 5.47368C13.9435 5.07713 14.3845 4.89343 14.7652 5.06338Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.34315 3.34315 2 5 2H13C14.2866 2 15.384 2.80991 15.8103 3.9477C15.6788 3.84952 15.5341 3.76396 15.3766 3.69367C14.1924 3.16505 12.8767 3.75641 12.4009 4.88438L11.3848 7.212C10.1933 7.27596 9.5 8.32817 9.5 9.26978V9.83064C9.5 10.5584 9.91411 11.3521 10.6523 11.7047L11.091 15.2196C11.2369 16.389 12.1855 17.5 13.5698 17.5H16V19C16 20.6569 14.6569 22 13 22H5C3.34315 22 2 20.6569 2 19V5ZM6 18.25C5.58579 18.25 5.25 18.5858 5.25 19C5.25 19.4142 5.58579 19.75 6 19.75H12C12.4142 19.75 12.75 19.4142 12.75 19C12.75 18.5858 12.4142 18.25 12 18.25H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingMobile);
export default __webpack_public_path__ + "static/media/shopping-mobile.fdd19cc03c9d7abe0e854e16e223df51.svg";
export { ForwardRef as ReactComponent };